import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  configApiRef,
} from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { scmAuthApiRef } from '@backstage/integration-react';

import { rootRouteRef, appExtensionRouteRef } from './routes';
import {
  appExtensionsApiRef,
  CatalogAppExtensionsClient,
  appExtensionPreviewImageApiRef,
  GithubPreviewImageClient,
} from './api';

export const appExtensionsPlugin = createPlugin({
  id: 'app-extensions',
  apis: [
    createApiFactory({
      api: appExtensionsApiRef,
      deps: { catalogApi: catalogApiRef },
      factory: ({ catalogApi }) => new CatalogAppExtensionsClient(catalogApi),
    }),
    createApiFactory({
      api: appExtensionPreviewImageApiRef,
      deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
      factory: ({ configApi, scmAuthApi }) =>
        new GithubPreviewImageClient({ configApi, scmAuthApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    extension: appExtensionRouteRef,
  },
});

export const AppExtensionsPage = appExtensionsPlugin.provide(
  createRoutableExtension({
    name: 'AppExtensionsPage',
    component: () =>
      import('./components/AppExtensionsList').then(m => m.AppExtensionsList),
    mountPoint: rootRouteRef,
  }),
);

export const AppExtensionPage = appExtensionsPlugin.provide(
  createRoutableExtension({
    name: 'AppExtensionPage',
    component: () =>
      import('./components/AppExtensionDetail').then(m => m.AppExtensionDetail),
    mountPoint: appExtensionRouteRef,
  }),
);
